declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
    gtag: (...args: unknown[]) => void
    dataLayer: unknown[]
  }
}

// ─── Meta Pixel ───────────────────────────────────────────
const META_PIXEL_ID = '1700478381670473'

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Also add noscript fallback pixel
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  // Meta Pixel AddToCart
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'The Paw-sitive Freedom Bundle',
      content_type: 'product',
      value: 37,
      currency: 'USD',
    })
  }

  // GA4 AddToCart
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: 'USD',
      value: 37,
      items: [
        {
          item_id: '53021114695996',
          item_name: 'The Paw-sitive Freedom Bundle',
          price: 37,
          quantity: 1,
        },
      ],
    })
  }
}

// ─── Google Analytics 4 ───────────────────────────────────
// IMPORTANT: Replace this with your actual GA4 Measurement ID
const GA4_MEASUREMENT_ID = 'G-XXXXXXXXXX'

export function initGA4() {
  if (typeof window === 'undefined') return
  if (window.gtag) return

  // Load gtag.js script
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`
  document.head.appendChild(script)

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: true,
    cookie_flags: 'SameSite=None;Secure',
    linker: {
      domains: ['floctiva.com', '15-minutes.floctiva.com'],
    },
  })
}
